<template>
  <div class="row rfc-massive-alerts mx-3 my-3">
    <div class="col-lg-7">
      <p class="mb-0">{{ t("components.massive_alerts.info_first") }}</p>
      <p class="mb-lg-0" v-html="infoMessage" />
    </div>
    <div
      class="col-lg d-flex align-items-center justify-content-lg-end flex-wrap"
    >
      <input
        type="file"
        id="assetsFieldHandle"
        class="d-none"
        ref="file"
        accept=".csv"
        @change="onUpload"
      />
      <label
        for="assetsFieldHandle"
        id="file-selector-text"
        class="col-12 col-md-6 btn btn-primary mb-3 mb-md-0 py-2 cursor-pointer"
        v-if="!loading_massive"
      >
        <i class="fas fa-cloud-upload-alt pr-2"></i>
        {{ t("components.massive_alerts.upload_file") }}
      </label>
      <label
        id="file-loading-text"
        v-else
        for=""
        class="col-12 col-md-6 btn btn-primary mb-3 mb-md-0 py-2"
      >
        <i class="fas fa-cloud-upload-alt pr-2"></i>
        {{ t("components.massive_alerts.uploading_file") }}
      </label>
      <button
        id="file-download-button"
        @click="downloadCSVFormat"
        class="col-12 offset-md-1 col-md py-2 btn btn-outline-primary"
      >
        <i class="fas fa-cloud-download-alt pr-2"></i>
        {{ t("components.massive_alerts.download_format") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import mixins from "common/mixins";

export default {
  name: "massive-alerts-vue",
  mixins: [mixins.translate],
  data() {
    return {
      headerCSV: false
    };
  },
  methods: {
    downloadCSVFormat() {
      var csvFileDataExample = [
        ["Ejemplo nombre RFC 1", "DASD83HASDA1"],
        ["Ejemplo nombre RFC 2", "DASD83HASDA2"],
      ]
      var csvHeader = "Nombre,RFC\n"

      csvFileDataExample.forEach(function (row) {
        csvHeader += row.join(",")
        csvHeader += "\n"
      })
      var hiddenElement = document.createElement("a")
      hiddenElement.href = "data:text/csvcharset=utf-8," + encodeURI(csvHeader)
      hiddenElement.target = "_blank"

      hiddenElement.download = "Formato_rfc.csv"
      hiddenElement.click()
    },
    async onUpload(event) {
      const file = event.target.files[0]
      let csvPattern = new RegExp('.+(\.csv)$')

      if(csvPattern.test(file.name)){
        await this.create_massive_alerts(file)
      }else{
        this.$store.commit("rfc_alerts/add_action_error", { key: 'formatError', value: I18n.t('components.massive_alerts.format_invalid')})
      }
      this.$emit('massive:updated')
      setTimeout(() => {
        this.$store.commit("rfc_alerts/clear_action_error")
        this.$store.commit("rfc_alerts/clear_action_messages")
      }, 15000)
    },
    ...mapActions("rfc_alerts", ["create_massive_alerts"])
  },
  computed: {
    infoMessage() {
      return I18n.t("components.massive_alerts.info_second")
    },
    ...mapState("rfc_alerts", [
      "loading_massive",
      "errors",
      "massiveErrorLines",
      "loading"
    ])
  }
};
</script>
